"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMutateAllowedAdapter = exports.isMutateAllowed = exports.isPathPermissionAllowed = exports.getOperationModePathPermissions = exports.operationModePathPermissions = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
exports.operationModePathPermissions = {
    admin: ['*'],
    client: ['*'],
    implementation_portal_client: [
        'facilityMechanics.*',
        'loanMechanicsV1.*',
        'liabilityAccounts.*',
        'fundingRequestMechanics.*',
    ],
};
const getOperationModePathPermissions = (operationMode) => exports.operationModePathPermissions[operationMode];
exports.getOperationModePathPermissions = getOperationModePathPermissions;
const isPathPermissionAllowed = ({ permissionPath, path, }) => {
    (0, common_1.finleyAssert)(permissionPath.length > 0, 'permission path must not be empty');
    const pathSegments = path.split('.');
    const permissionSegments = permissionPath.split('.');
    const lastPermissionSegment = _.last(permissionSegments);
    (0, common_1.finleyAssert)(lastPermissionSegment, 'last permission segment must exist');
    // if permission ends with *, deeply extend to match all subpaths
    // such that we do not need to manually declare all subpaths
    // individually
    if (lastPermissionSegment === '*') {
        // eslint-disable-next-line no-restricted-syntax
        while (permissionSegments.length < pathSegments.length) {
            permissionSegments.push('*');
        }
    }
    if (permissionSegments.length !== pathSegments.length)
        return false;
    // eslint-disable-next-line no-restricted-syntax
    for (let idx = 0; idx < pathSegments.length; idx += 1) {
        const permissionSeg = permissionSegments[idx];
        if (permissionSeg === '*')
            continue;
        const pathSeg = pathSegments[idx].replace(/\[[0-9]+\]/g, '[]'); // replace array indexes with numberless brackets []
        if (permissionSeg === pathSeg)
            continue;
        return false;
    }
    return true;
};
exports.isPathPermissionAllowed = isPathPermissionAllowed;
const isMutateAllowed = ({ path, operationMode, }) => {
    const pathPermissions = (0, exports.getOperationModePathPermissions)(operationMode);
    return _.some(pathPermissions, (permissionPath) => (0, exports.isPathPermissionAllowed)({ permissionPath, path }));
};
exports.isMutateAllowed = isMutateAllowed;
const isMutateAllowedAdapter = (operationMode) => {
    return (path) => (0, exports.isMutateAllowed)({ path, operationMode });
};
exports.isMutateAllowedAdapter = isMutateAllowedAdapter;
//# sourceMappingURL=wipPermissions.js.map